import { Namespace } from '../../enum';
import {
    createSelector,
    createStructuredSelector,
} from 'reselect';
import { RootState } from '../../interface';
import { initialState } from './reducer';

const selectState = (state: RootState) => state[Namespace.OVERLAY] || initialState;

export const selectOverlayState = createSelector(selectState, state => state);
export const selectIsLoaded = createSelector(selectState, state => state.isLoaded);
export const selectIsOpen = createSelector(selectState, state => state.isOpen);
export const selectActiveContent = createSelector(selectState, state => state.activeContent);
export const selectLoading = createSelector(selectState, state => Object.keys(state.loadingStatus).length > 0);

export const mapStateToProps = createStructuredSelector({
    isLoading: selectLoading,
    isLoaded: selectIsLoaded,
    isOpen: selectIsOpen,
    activeContent: selectActiveContent,
});

/**
 * Overlay states by selector
 */
export type State = ReturnType<typeof mapStateToProps>;
